import React, { Component } from 'react';
import { connect } from 'react-redux'
import { EventPageTemplateBlank } from '../';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faArrowLeft, faPrint} from '@fortawesome/fontawesome-free-solid';

import './eventQrcodePage.scss';


class EventQrcodePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventID: null,
            data: {},
            logo: null
        }
    }

    static getDerivedStateFromProps(props, state) {
        const eventID = props.events.currentEventID;
        const events = props.events.list;
        const currentEvent = events && events[eventID] ? events[eventID] : false;

        var nextState = {};

        if(state.eventID !== eventID) {
            nextState.eventID = eventID;
        }
        
        if(props.user.data && props.user.data.logo && props.user.data.logo !== state.logo) {
            nextState.logo = props.user.data.logo.url;
        }

        if(currentEvent && !Object.is(currentEvent, state.data)) {
            nextState.data = currentEvent;
        }
            
        if(Object.is(nextState, {})) return null;
        return nextState;
    }

    render() {
        const website = this.state.data.website;
        const qrcode = website && website.qrcode;
        const link = website && website.url;
        const logo = this.state.logo;

        return (
            <EventPageTemplateBlank>
                <div id="eventQrcodePage">
                    <div className="highlight">
                        לחצו על הכותרות כדי לערוך אותן&nbsp;
                        <FontAwesomeIcon icon={faArrowLeft}/>
                    </div>
                    <div className="printButton" onClick={window.print}>
                        <FontAwesomeIcon icon={faPrint}/> הדפסה    
                    </div>
                    <div className="userLogo" style={{display: logo ? 'block' : 'none'}}>
                        <img src={logo} alt="logo"/>
                    </div>
                    <div className="qrcodeTitle" ref={edit => edit && edit.focus()}  suppressContentEditableWarning="true" contentEditable="true">
                        סרקו, צלמו, קבלו מגנט
                    </div>
                    <div className="qrcodeSubTitle" suppressContentEditableWarning="true" contentEditable="true">
                        צלמו את עצמכם והמגנט יחכה לכם בעמדה
                    </div>
                    <div id="svgContainer" dangerouslySetInnerHTML={{__html: qrcode}} />
                    <a className="qrcodeLink">
                        {link}
                    </a>
                </div>
            </EventPageTemplateBlank>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer,
        user: state.userReducer
    }
}

const EventQrcodePageWithRedux = connect(mapStateToProps)(EventQrcodePage);

export {EventQrcodePageWithRedux as EventQrcodePage};


// WEBPACK FOOTER //
// ./src/components/EventPage/qrcode/EventQrcodePage.jsx